import React, { useState } from 'react';
import { LayoutDashboardIcon, BarChart3Icon, DollarSignIcon, TruckIcon, ClipboardCheckIcon, BadgeIcon, UsersIcon, CalendarIcon, ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, ShieldIcon, GlobeIcon, PieChartIcon, LineChartIcon, MapIcon, BellIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, MoreHorizontalIcon } from 'lucide-react';
import { DashboardOverview } from '../components/dashboard/alternative/DashboardOverview';
import { OrdersOverview } from '../components/dashboard/alternative/OrdersOverview';
import { QuotesOverview } from '../components/dashboard/alternative/QuotesOverview';
import { ClaimsOverview } from '../components/dashboard/alternative/ClaimsOverview';
import { SubscriptionOverview } from '../components/dashboard/alternative/SubscriptionOverview';
import { LanguageSelector } from '../components/LanguageSelector';
export function DashboardPageAlternative() {
  const [activeSection, setActiveSection] = useState('overview');
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900" data-id="element-8201">
      {/* Dashboard header with navigation */}
      <div className="relative z-10 flex flex-col border-b border-white/10" data-id="element-8202">
        <div className="flex items-center justify-between p-6" data-id="element-8203">
          <div className="flex items-center" data-id="element-8204">
            <div className="p-2 mr-3 bg-blue-600 rounded-lg" data-id="element-8205">
              <LayoutDashboardIcon size={20} className="text-white" data-id="element-8206" />
            </div>
            <h1 className="text-2xl font-bold text-white" data-id="element-8207">Dashboard</h1>
          </div>
          <div className="flex items-center space-x-4" data-id="element-8208">
            <LanguageSelector data-id="element-8209" />
            <div className="relative" data-id="element-8210">
              <BellIcon size={20} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8211" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8212">
                3
              </span>
            </div>
            <div className="bg-blue-800/50 rounded-full w-8 h-8 flex items-center justify-center" data-id="element-8213">
              <span className="text-white font-medium" data-id="element-8214">JD</span>
            </div>
          </div>
        </div>
        {/* Horizontal navigation */}
        <div className="flex px-6 pb-2 overflow-x-auto" data-id="element-8215">
          <NavButton icon={<LayoutDashboardIcon size={18} data-id="element-8217" />} label="Overview" active={activeSection === 'overview'} onClick={() => setActiveSection('overview')} data-id="element-8216" />
          <NavButton icon={<TruckIcon size={18} data-id="element-8219" />} label="Orders" active={activeSection === 'orders'} onClick={() => setActiveSection('orders')} data-id="element-8218" />
          <NavButton icon={<DollarSignIcon size={18} data-id="element-8221" />} label="Quotes" active={activeSection === 'quotes'} onClick={() => setActiveSection('quotes')} data-id="element-8220" />
          <NavButton icon={<ClipboardCheckIcon size={18} data-id="element-8223" />} label="Claims" active={activeSection === 'claims'} onClick={() => setActiveSection('claims')} data-id="element-8222" />
          <NavButton icon={<BadgeIcon size={18} data-id="element-8225" />} label="Subscription" active={activeSection === 'subscription'} onClick={() => setActiveSection('subscription')} data-id="element-8224" />
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 p-6 overflow-auto" data-id="element-8226">
        {activeSection === 'overview' && <DashboardOverview data-id="element-8227" />}
        {activeSection === 'orders' && <OrdersOverview data-id="element-8228" />}
        {activeSection === 'quotes' && <QuotesOverview data-id="element-8229" />}
        {activeSection === 'claims' && <ClaimsOverview data-id="element-8230" />}
        {activeSection === 'subscription' && <SubscriptionOverview data-id="element-8231" />}
      </div>
    </div>;
}
function NavButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button onClick={onClick} className={`flex items-center px-4 py-2 mr-2 rounded-lg transition-colors ${active ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-blue-800/50 hover:text-white'}`} data-id="element-8232">
      <span className="mr-2" data-id="element-8233">{icon}</span>
      <span data-id="element-8234">{label}</span>
    </button>;
}